import React, { useState, useEffect } from 'react';
import NumberFlow, { continuous } from '@number-flow/react';

export default function PeopleCount() {
  const [peopleCount] = useState({ alumni: 700, enrolled: 250 , faculty: 20  }); //total alumni was 707 (for information)
  const [isInView, setIsInView] = useState(false);
  const [counts, setCounts] = useState({ alumni: 0, enrolled:0, faculty: 0 });

  useEffect(() => {
    const element = document.getElementById('numberFlowSection');
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.unobserve(entry.target); // stop observing after it becomes visible
        }
      },
      {
        threshold: 0.5, // 50% of the element should be visible
      }
    );

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  useEffect(() => {
    if (isInView) {
      setCounts({
        alumni: peopleCount.alumni,
        enrolled: peopleCount.enrolled,
        faculty: peopleCount.faculty,
      });
    }
  }, [isInView, peopleCount]);

  return (
    <div
      id="numberFlowSection"
      className="m-10 flex flex-col md:flex-row text-center items-center justify-around p-8 text-3xl font-normal text-white bg-theme font-inter"
      style={{ textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)" }}
    >
      <div className="m-4">
        <NumberFlow
          willChange
          value={counts.alumni}
          plugins={[continuous]}
          transformTiming={{ duration: 1500, easing: 'ease-out' }}
          spinTiming={{ duration: 1500, easing: 'ease-out' }}
          opacityTiming={{ duration: 350, easing: 'ease-out' }}
          suffix="+"
        />
        <p>Alumni</p>
      </div>
      <div className="m-4">
        <NumberFlow
          willChange
          value={counts.enrolled}
          plugins={[continuous]}
          transformTiming={{ duration: 1500, easing: 'ease-out' }}
          spinTiming={{ duration: 1500, easing: 'ease-out' }}
          opacityTiming={{ duration: 350, easing: 'ease-out' }}
          suffix="+"
        />
        <p>Enrolled</p>
      </div>
      <div className="m-4">
        <NumberFlow
          willChange
          value={counts.faculty}
          plugins={[continuous]}
          transformTiming={{ duration: 1500, easing: 'ease-out' }}
          spinTiming={{ duration: 1500, easing: 'ease-out' }}
          opacityTiming={{ duration: 350, easing: 'ease-out' }}
          suffix="+"
        />
        <p>Faculties</p>
      </div>
    </div>
  );
}
